import { ReactElement } from 'react';

import { useTheme, useMediaQuery, Box, Stack } from '@mui/material';

import { merge } from 'lodash';

import { PanelProps } from './types';

export default function Panel(props: PanelProps): ReactElement {
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down('sm'));
  const isSm = useMediaQuery(theme.breakpoints.down('md'));

  const { asset, renderLabel, renderDescription, sx } = props;

  return (
    <Box
      sx={{
        ...merge(
          {
            'width': '100%',
            'height': '100vh',

            'display': 'flex',
            'flexDirection': 'column',
            'alignItems': 'center',
            'justifyContent': 'center',

            'position': 'relative',

            'm': 0,
            'px': isXs ? 2 : 4,
            'py': isXs ? 1 : 2,

            '& .MuiTypography-root': {
              color: 'white'
            },

            '& .MuiTypography-h1': {
              lineHeight: 1
            },

            '& .MuiTypography-h2': {
              lineHeight: '60px'
            },

            '& .MuiTypography-h6': {
              fontWeight: 400
            },

            '& .MuiTypography-subtitle2': {
              fontWeight: 400
            }
          },
          sx
        )
      }}>
      {/* Background Image */}
      <Box width='100%' height='100vh' position='absolute' top={0} left={0}>
        {asset}
      </Box>

      {/* Content */}
      <Stack
        width='100%'
        spacing={isXs ? 1 : 2}
        position='relative'
        zIndex={1}
        sx={{ px: isXs ? 3 : isSm ? 7 : 14 }}>
        {renderLabel({ align: 'left', whiteSpace: 'pre-wrap', variant: isSm ? 'h2' : 'h1' })}
        {renderDescription({
          align: 'left',
          whiteSpace: 'pre-wrap',
          fontWeight: 500,
          variant: isSm ? 'subtitle1' : 'h6'
        })}
      </Stack>
    </Box>
  );
}
